<template>
  <div class="vote-container min-h-screen w-full text-white relative pb-12">
    <div class="px-6 py-12 lg:max-w-xl lg:mx-auto relative h-full lg:text-center">
      <div v-if="!sent && !error">
      <h1 class="lg:text-6xl lg:mb-12">Выбор тура</h1>
      <p class="lg:text-2xl lg:mb-44">Нажмите на кнопку тура,<br class="lg:hidden"> который хотите сыграть.</p>
      <button
          v-for="(vote, index) in voteOptions" :key="index"
          :style="`border: 5px solid ${index ? '#51E5FF' : '#FFD00A'}`"
          class="w-full text-xl block text-white px-6 py-5 rounded-xl font-bold mb-6"
          :class="[disableBtns?'opacity-50 cursor-not-allowed':'hover-up']"
          :disabled="disableBtns"
          @click.once="submitVote(vote)">{{vote.name}}
      </button>
      <div class="w-full absolute pin-b pin-l flex justify-center mb-20">
      <img class="w-40" src="@/assets/SVG/mozgo-logo-vote.svg" alt="mozgo-logo-vote.svg">
      </div>
      </div>
      <div v-else-if="sent">
        <h1 class="lg:text-6xl lg:mb-12">Спасибо!</h1>
        <p class="lg:text-2xl lg:mb-44">Ваш голос учтен! <br class="lg:hidden">Результаты голосования<br class="lg:hidden"> будут на экране.</p>
      </div>
      <div v-else>
        <h1 class="lg:text-6xl lg:mb-12">Упс!</h1>
        <p class="lg:text-2xl lg:mb-44">Кажется, что-то пошло<br class="lg:hidden"> не так. Обновите<br class="lg:hidden"> страницу и попробуйте<br class="lg:hidden"> проголосовать снова.</p>
      </div>
    </div>
  </div>
</template>
<script>
import base from '@/clients/base';
import * as Cookies from 'js-cookie';

export default {
  name: 'game-vote',
  data() {
    return {
      voteOptions: [],
      sent: false,
      error: false,
      disableBtns: false,
    };
  },
  mounted() {
    base.get(`/api/vote/${this.$route.params.id}/variants`)
      .then((response) => {
        this.voteOptions = [];
        response.data.forEach((option) => {
          this.voteOptions.push(option);
        });
      }).catch((error) => {
        console.log(error);
      });

    const oldVoteId = Cookies.get('voteId');
    if (oldVoteId === this.$route.params.id) {
      this.disableBtns = true;
      this.sent = true;
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth < 768;
    },
  },
  methods: {
    submitVote(vote) {
      base.post('/api/vote', {
        uuid: this.$route.params.id,
        vote: vote.name,
      }).then(() => {
        this.sent = true;
        Cookies.set('voteId', this.$route.params.id, { expires: 1 });
      }).catch((error) => {
        console.log(error);
        this.error = true;
      });
    },
  },
};
</script>
<style scoped>
.vote-container {
  background-image: url("../../assets/vote_page_background.png");
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 10000;
  font-family: Montserrat;
}

@media only screen and (max-width: 760px) {
  .vote-container {
    background-image: url("../../assets/vote_page_background_mobile.jpg");
  }
}
h1 {
  @apply text-4xl mb-6 leading-normal
}
p {
  @apply text-lg mb-6 leading-tight
}


</style>
<style>
body {
  -webkit-overflow-scrolling: touch;
   overflow: hidden;
}
</style>
